import { retrieveErrors } from '@widergy/web-utils/lib/message';
import { AlertHandler } from '@widergy/energy-ui';

import { message } from 'utils/stringUtils';
import { actionCreators as AlertActions } from 'redux/alertHandlers';
import store from 'redux/store';

export const handleUploadFailure = error =>
  AlertHandler.error(retrieveErrors(error), message('FormCreator:uploadFileError'));

export const handleSubmitFormFailure = (formType, formName, submitFormFailure, error, isPublic) => {
  const errorForm = retrieveErrors(error, message('DefaultMessages:submitFormFailure'));
  store.dispatch(AlertActions.openModal({ content: errorForm }));
  store.dispatch(submitFormFailure(errorForm, formType, formName, isPublic));
};
